<!--
	Unfortunately, vue-snotify has no reactive slots yet so we cannot use things such as
	TextResources or general vue components inside that update reactively. As a workaround
	we beam our components into this notification with portal-vue.
-->
<template>
	<div v-if="toast != null">
		<Teleport v-if="targetReady" :to="`#${portal}`">
			<slot />
		</Teleport>
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { type SnotifyToast } from "vue3-snotify";

@Component
export class Button extends Vue {
	@Prop({ required: true }) toast!: SnotifyToast | null;
	@Prop({ required: true, type: String }) portal!: string;

	get targetReady() {
		if (this.toast == null) {
			return false;
		}

		for (const button of Array.from(document.getElementsByTagName("button"))) {
			if (button.childNodes.length === 1
				&& button.childNodes[0].nodeType === 3
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				&& button.childNodes[0].nodeValue!.trim() === this.portal) {
				// This button contains a single text node.
				// Let's replace it with something that we can mount a portal into.
				button.innerHTML = `<span id="${this.portal}"></span>`;
			}
		}

		return true;
	}
}

export default toNative(Button);
</script>
